import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import { Navigation, Link } from "react-router";
import SDKSidebar from "js/utilities/sdk-sidebar"
import UserHandler from "js/utilities/user-handler";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import { ZOOM_ICON } from "js/config.jsx";

import CONFIGURE_ID from "resources/img/configure_id.png";

export default React.createClass({
  displayName: "going-production",
  scrollToGuide : null,
  scrollingEl : null,
  getInitialState: function() {
    var scrollToElement = initDeepLinkData(this.props);
    return {
      scrollToElement: scrollToElement
    };
  },

  componentDidMount: function() {
    mountCode(this);
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container quick-guides-pages">

              <section id="Introduction">
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2 id="going-production">Going Production</h2>
                </div>
                <p>This page will walk you through the steps to take your App into Production.</p>
                <hr/>
              </section>

              <section>
                <h3 id="prerequisites">Prerequisites</h3>
                <p>This guide assumes you have entered in a commercial agreement with FaceTec, and you are ready to finalize your integration.  This means you have already done the following steps:</p>
                <ul>
                  <li><p>You have <Link to="/getting-started">Integrated FaceTec SDKs into Your App and Tested it.</Link></p></li>
                  <li><p>You have <Link to="/quote">Requested a Quote.</Link> and spoken with our commercial team.</p></li>
                  <li><p>You have <Link to="/downloads">Access to the FaceTec Server SDK</Link>.</p></li>
                  <li><p>You have <Link to="/zoom-server-quickstart">Performed Initial Server SDK Development</Link> and <Link to="/server-integration">Integrated FaceTec Server into Your Infrastructure</Link>.</p></li>
                </ul>
                <hr />
              </section>


              <section>
                <h3 id="configuring-your-app-for-production">Configuring Your App For Production</h3>
                <p>Once the above steps are complete, here are the next steps you need to take to get configured for a production deployment to real users:</p>
                <ol>
                  <li><p>Review and understand the difference between <Link to="/licensing">Development and Production Keys</Link>.</p></li>
                  <li><p>Configure your IDs and Domains for <Link to="/account">Your App Settings in Your Account Page</Link>.</p></li>
                  <li><p>Review, understand, and follow FaceTec's <Link to="/usage-logs">Usage Log Policy and Usage Log Configuration Steps</Link>.  You must confirm that not only have you uploaded a test file, but that you have automated SFTP log transfer set up on a daily basis.</p></li>
                  <li><p>Your App <strong>must be</strong> using the latest version of FaceTec SDKs.</p></li>
                </ol>
                <hr />
                <h4 id="example-setting-ids">Example: Setting Domains and Package IDs</h4>
                <p><img style={{marginTop: "1px", maxHeight: "300px", maxWidth: "100%"}} src={CONFIGURE_ID} /></p>
                <blockquote><p><strong>Note:</strong> You MUST configure ALL Domain Names (Browser), <a target="_blank" href="https://developer.android.com/studio/build/application-id">App IDs (Android)</a>, and <a target="_blank" href="https://developer.apple.com/documentation/appstoreconnectapi/bundle_ids">Bundle IDs (iOS)</a> for your Apps.  As a security feature, FaceTec Production Keys will not initialize unless they are in the Apps you specify.</p></blockquote>
              </section>

              <hr />

              <section>
                <h3 id="ready">Ready?</h3>
                <p>Once the above steps are complete, please contact your FaceTec Commercial or Technical Contact for final review.</p>
              </section>

              <hr />

              <section>
                <h3 id="production-license-download">Production Key Download</h3>
                <p>Once your Production Keys are generated, they are available in your App Details on your <Link to="/account">Account Page</Link>.</p>
              </section>

              <hr />

              <section>
                <h3 id="integrating-production-licenses">Integrating Production Keys</h3>
                <p><strong>DO NOT</strong> hard code your FaceTec Key into the <code>initializeWithLicense</code> API in your Apps.  Instead, serve FaceTec SDK Keys from an API or dynamic file that you pass into the <code>initializeWithLicense</code> API in your Apps.  This way, you will not need to compile your client or server code when you update your FaceTec Licenses.</p>
              </section>

              <SDKSidebar menuType="main" title="Going Production"/>

            </div>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/going-production-overview.jsx